import StoriesSliderDesktop from './StoriesSliderDesktop'

export default StoriesSliderDesktop
